import { Divider, IconButton, Paper } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Button } from "../../../controls";
import { Model, UseForm } from "../../../hooks";
import { Alert, Form, Tabs } from "../../../layout";
import { ArrowBackRounded } from "@mui/icons-material";
import { RmvEmptyProp, splitName, ToFormData } from "../../../hooks/Method";
import { AppContext } from "../../../App";
import { API, action, controller } from "../../../api/api";
import GeneralFields from "./GeneralFields";
import AddressFields from "./AddressFields";
import AdditionalFields from "./AdditionalFields";
import CreditDebitCardFields from "./CreditDebitCardFields";

const AddEditCstmr = ({
  // adding from other page params.
  setShowForm,
  openFromOtherSide = false,
  customerName = "",
  handleResult,
}) => {
  const { id } = useParams();
  const { CstmrMdl } = Model();
  const navigate = useNavigate();
  const { authUser } = useContext(AppContext);
  const {
    values,
    errors,
    setErrors,
    handleInpChg,
    setValues,
    handleFile,
    handleInpDate,
  } = UseForm(CstmrMdl);
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState({
    isOpen: false,
    type: "",
    title: "",
    subTitle: "",
  });

  useEffect(() => {
    if (customerName) {
      const { firstName, lastName } = splitName(customerName);
      setValues((j) => ({ ...j, firstName, lastName }));
    }
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customerName]);

  useEffect(() => {
    id &&
      API(controller.Customer + action.GetById).getById(id, (res) => {
        if (res && res.status === 200) {
          var val = RmvEmptyProp(res.result);
          setValues((x) => ({ ...x, ...val }));
        }
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const validateForm = () => {
    let temp = {};
    temp.firstName = values.firstName !== "" ? "" : "First name is required.";
    temp.lastName = values.lastName !== "" ? "" : "Last name is required.";

    setErrors({ ...temp });
    return Object.values(temp).every((x) => x === "");
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      if (
        !values.id &&
        values.openingBalance &&
        parseFloat(values.openingBalance || 0)
      ) {
        setAlert({
          isOpen: true,
          type: "confirmation",
          title: "Confirm Opening Balance",
          subTitle:
            "Please review the customer's opening balance carefully. Once it is set, it cannot be modified.",
          onConfirm: () => {
            handleConfirmSubmit();
          },
        });
      } else handleConfirmSubmit();
    }
  };

  const handleConfirmSubmit = () => {
    setLoading(true);
    const onComplete = (res) => {
      setLoading(false);

      if (res && res.result.id && (res.status === 201 || res.status === 200)) {
        if (openFromOtherSide && handleResult) {
          setShowForm(false);
          handleResult(res.result);
        } else
          setAlert({
            isOpen: true,
            type: "success",
            title: "Success",
            subTitle: res.msg,
            onClick: () => navigate("/customers"),
          });
      } else if (res)
        setAlert({
          isOpen: true,
          type: "error",
          title: "Error",
          subTitle: res.msg,
        });
    };
    if (values.id === 0) {
      values.outletId = authUser.outletId ? authUser.outletId : "";
      values.orgId = authUser.orgId;
      values.userId = authUser.id;
      API(controller.Customer + action.Post).post(
        ToFormData(RmvEmptyProp(values)),
        onComplete
      );
    } else {
      API(controller.Customer + action.Put).put(
        ToFormData(
          RmvEmptyProp({ ...values, updateDate: new Date().toISOString() })
        ),
        onComplete
      );
    }
  };

  const handleBack = () => {
    openFromOtherSide ? setShowForm(false) : navigate(-1);
  };

  return (
    <>
      <Form noValidate>
        <Paper>
          <div className="mb-[10px] flex justify-between items-center pt-[10px] pl-[10px] pr-[10px]">
            <div className="flex items-center gap-[10px]">
              <div>
                <IconButton size="small" onClick={handleBack}>
                  <ArrowBackRounded />
                </IconButton>
              </div>
              <div>
                <h1 className="text-[22px] font-medium text-gray-500 uppercase">
                  {id ? "Edit" : "Add"} Customer
                </h1>
              </div>
            </div>

            <div>
              <Button loading={loading} onClick={handleSubmit}>
                {id ? "Save Changes" : "Submit"}
              </Button>
            </div>
          </div>
          <Divider />
          <div className="pl-[15px] pr-[15px] pb-[15px]">
            <Tabs
              className="mt-[30px]"
              header={[
                { label: "General Fields", icon: "" },
                { label: "Address Fields", icon: "" },
                { label: "Additional Fields", icon: "" },
                { label: "Credit/Debit Card", icon: "" },
              ]}
            >
              {/* General Info */}
              <GeneralFields {...{ values, setValues, errors, handleInpChg }} />

              {/* Addresses */}
              <AddressFields {...{ values, handleInpChg }} />

              {/* Additional informations */}
              <AdditionalFields
                {...{
                  values,
                  setValues,
                  handleFile,
                  handleInpChg,
                  handleInpDate,
                }}
              />

              {/*  Credit/Debit Card  */}
              <CreditDebitCardFields
                {...{ values, handleInpChg, handleInpDate }}
              />
            </Tabs>
          </div>
        </Paper>
      </Form>
      {/* Alert  */}
      <Alert alert={alert} setAlert={setAlert} />
    </>
  );
};

export default AddEditCstmr;
